import { render, staticRenderFns } from "./departmentEdit.vue?vue&type=template&id=462aa12d&"
import script from "./departmentEdit.vue?vue&type=script&lang=js&"
export * from "./departmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./departmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports